import { Interval } from 'luxon';

type IntervalCountObject = {
  interval: Interval;
  count: number;
  eventType: string | null;
};

type IntermediateReturn = {
  [key: string]: IntervalCountObject;
};

type FinalReturn = IntervalCountObject[];

export function countReservationIntervalIntersections(
  reservations: {
    interval: Interval;
    eventType: string | null;
  }[],
  ret: IntermediateReturn = {},
  count?: number
): FinalReturn {
  for (const reservation of reservations) {
    let intersects = false;

    for (const k of Object.keys(ret)) {
      const retInterval = ret[k].interval;
      const retEventType = ret[k]?.eventType || null;
      const intersection = retInterval.intersection(reservation.interval);

      if (
        intersection &&
        !retInterval.abutsEnd(reservation.interval) &&
        !retInterval.abutsStart(reservation.interval)
      ) {
        intersects = true;

        const existingCount = ret[k].count;
        const leftover = retInterval.difference(reservation.interval).map(i => {
          return {
            interval: i,
            eventType: retEventType,
          };
        });
        const unfinishedBusiness = reservation.interval
          .difference(retInterval)
          .map(i => {
            return {
              interval: i,
              eventType: retEventType,
            };
          });

        delete ret[k];
        ret[intersection.start.valueOf()] = {
          interval: intersection,
          count: existingCount + 1,
          eventType: reservation.eventType,
        };
        countReservationIntervalIntersections(leftover, ret, existingCount);
        countReservationIntervalIntersections(unfinishedBusiness, ret);

        break;
      }
    }

    if (!intersects) {
      ret[reservation.interval.start.valueOf()] = {
        interval: reservation.interval,
        count: count || 1,
        eventType: reservation.eventType,
      };
    }
  }

  return Object.values(ret).sort((a, b) => {
    return a.interval.start.valueOf() - b.interval.start.valueOf();
  });
}
